/*
 *
 *  * (C) Copyright 2006-2020 hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * All Rights Reserved.
 *  *
 *  * These materials are unpublished, proprietary, confidential source code of
 *  * hSenid Mobile Solutions (Pvt) Limited and constitute a TRADE SECRET
 *  * of hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * hSenid Mobile Solutions (Pvt) Limited retains all title to and intellectual
 *  * property rights in these materials.
 *  *
 *
 */

import "../../resources/css/style.css";
import "../../resources/css/fontawesome-free-5.15.1-web/css/all.css";

import React from "react";
import { ConnectedRouter } from "connected-react-router";
import { history } from "../../router/router";
import { Switch, Route, Redirect } from "react-router-dom";
import { useMainPageDataSelector } from ".";
import AppDetailsPage from "../Pages/AppDetailsPage/AppDetailsPage";
import AppsByCategoryPage from "../Pages/AppsByCategoryPage/AppsByCategoryPage";
import AppsByClassificationPage from "../Pages/AppsByClassification/AppsByClassificationPage";
import HomePage from "../Pages/HomePage/HomePage";
import MyAppsPage from "../Pages/MyAppsPage/MyAppsPage";
import SearchResultsPage from "../Pages/SearchResultsPage/SearchResultsPage";
import * as configData from "../../config.json";
import { CLASSIFICATION } from "../../constants";
import Body from "../Layouts/Body";
import ScrollToTop from "../Layouts/ScrollToTop";

export function MainUi() {
  const authState = useMainPageDataSelector().authState;

  return (
    <ConnectedRouter history={history}>
      <ScrollToTop />
      <Switch>
        <Body>
          <Route exact path="/" render={() => <HomePage />} />
          <Route
            path="/new-apps"
            render={() => (
              <AppsByClassificationPage
                key="NEWLY_ADDED"
                classification={CLASSIFICATION.NEWLY_ADDED}
                mainHeading={configData.MAIN_TITLES.NEWLY_ADDED}
              />
            )}
          />
          <Route
            path="/top-rated-apps"
            render={() => (
              <AppsByClassificationPage
                key="TOP_RATED"
                classification={CLASSIFICATION.TOP_RATED}
                mainHeading={configData.MAIN_TITLES.TOP_RATED}
              />
            )}
          />
          <Route
            path="/most-used-apps"
            render={() => (
              <AppsByClassificationPage
                key="MOST_USED"
                classification={CLASSIFICATION.MOST_USED}
                mainHeading={configData.MAIN_TITLES.MOST_USED}
              />
            )}
          />
          <Route path="/app-details/:appId" render={() => <AppDetailsPage />} />
          <Route
            exact
            path="/app-by-category/:category"
            render={() => <AppsByCategoryPage />}
          />
          <Route
            exact
            path="/search-apps/:keyword"
            render={() => <SearchResultsPage />}
          />
          <Route
            exact
            path="/search-apps/"
            render={() => <SearchResultsPage />}
          />
          <Route
            path="/my-apps"
            render={() =>
              authState === true ? <MyAppsPage /> : <Redirect to="/" />
            }
          />
        </Body>
      </Switch>
    </ConnectedRouter>
  );
}
